export const EnumLang  = { 
    ca: "ca",
    en: "en",
    es: "es",
    oc: "oc",
  }
  
  